import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeClosed = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M15.75 6.481c.249.156.325.485.169.735a10.2 10.2 0 0 1-1.658 2.025l1.282 1.28a.534.534 0 0 1-.755.755l-1.347-1.347a9 9 0 0 1-2.845 1.432l.48 1.789a.533.533 0 0 1-1.031.276l-.489-1.823a9 9 0 0 1-1.556.13 9 9 0 0 1-1.556-.13l-.489 1.822a.533.533 0 1 1-1.03-.275l.479-1.789A9 9 0 0 1 2.559 9.93l-1.347 1.347a.533.533 0 0 1-.755-.754L1.738 9.24A10.2 10.2 0 0 1 .081 7.216a.533.533 0 0 1 .905-.565 9 9 0 0 0 1.888 2.17A7.96 7.96 0 0 0 8 10.666c2.995 0 5.5-1.594 7.014-4.016a.533.533 0 0 1 .735-.17",
		clipRule: "evenodd"
	})
});
const Memo = memo(SvgEyeClosed);
export default Memo;
